import ConstructionServices from "Services/http/endpoints/construction/ConstructionService";
import { PROJECT_BUILD_INFO_SUCCESS } from "Stores/actionTypes";
import StatusHandler from "Helpers/StatusHandler";

export const getProjectBuildInfo = (data) => {
  return async (dispatch) => {
    try {
      const response =
        await ConstructionServices.getListUniteDesignerBuild(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const projectBuildInfo = response.data.Value;
        dispatch({
          type: PROJECT_BUILD_INFO_SUCCESS,
          constructionData: projectBuildInfo,
          constructionPagination: response.data.Pagination,
        });
        return projectBuildInfo;
      }
    } catch (e) {}
  };
};

export const insertBuiltData = (data) => {
  return async () => {
    try {
      const response =
        await ConstructionServices.postInsertBuildUnitString(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value;
      } else {
        return false;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const managePartsCount = (data) => {
  return async () => {
    try {
      const response = await ConstructionServices.postSakhtUnitJson(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        return response.data.Value;
      } else {
        return false;
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};
